import { normIcao } from "./airportFrequencyLocal";

/**
 * Texas airport ICAO codes (US-TX). Expand this list as needed; used when inferring
 * Texas landings from destination when the log’s Texas-arrival flag is unset.
 */
const TEXAS_ICAO_RAW = [
  "KABI",
  "KADS",
  "KAFW",
  "KALI",
  "KAMA",
  "KAPF",
  "KARM",
  "KATT",
  "KAXH",
  "KBBD",
  "KBPG",
  "KBRO",
  "KBYY",
  "KCDS",
  "KCLL",
  "KCNW",
  "KCOM",
  "KCRP",
  "KCTX",
  "KCVB",
  "KDAL",
  "KDFW",
  "KDNL",
  "KDTO",
  "KDUX",
  "KDWH",
  "KELP",
  "KETN",
  "KGGG",
  "KGKY",
  "KGLS",
  "KGPM",
  "KGVT",
  "KGZN",
  "KHOU",
  "KHRL",
  "KHYI",
  "KIAH",
  "KILE",
  "KJCT",
  "KLBB",
  "KLFK",
  "KLRD",
  "KMAF",
  "KMWL",
  "KOCH",
  "KORG",
  "KPEQ",
  "KPPA",
  "KPRX",
  "KPSX",
  "KRBD",
  "KRND",
  "KRPH",
  "KSEP",
  "KSAT",
  "KSGR",
  "KSJT",
  "KSKF",
  "KSLR",
  "KSPF",
  "KSPS",
  "KTFP",
  "KTPL",
  "KTRL",
  "KTXW",
  "KTYR",
  "KVCT",
  "KWEA",
];

const TEXAS_ICAO = new Set(TEXAS_ICAO_RAW.map((c) => normIcao(c)));

export function isTexasDestinationIcao(icao: string): boolean {
  return TEXAS_ICAO.has(normIcao(icao));
}

export function texasDestinationIcaoSet(): ReadonlySet<string> {
  return TEXAS_ICAO;
}

const TEXAS_INFER_KEY = "flights_texas_infer_dest_v1";

export function loadTexasInferFromDestination(): boolean {
  try {
    const v = localStorage.getItem(TEXAS_INFER_KEY);
    if (v === "0") return false;
    if (v === "1") return true;
  } catch {
    /* ignore */
  }
  return true;
}

export function saveTexasInferFromDestination(on: boolean): void {
  try {
    localStorage.setItem(TEXAS_INFER_KEY, on ? "1" : "0");
  } catch {
    /* ignore */
  }
}
